import { RouteType } from "types/RouteType";
import { AccountDashboardStore } from "./AccountDashboard.Store";

const accountDashboardRoute: RouteType = {
  name: "Account Dashboard",
  path: "/crm/accounts/:id/dashboard",
  layout: "/app",
  hidden: true,
  viewportCard: {
    header: {
      title: "Account Dashboard",
      // component: () => import("./AccountDashboard.Header"),
      enableBackButton: true,
      enableRefreshButton: true,
    },
    body: {
      grayBackground: true,
      component: () => import("./AccountDashboard.Body"),
    },
  },
  group: "CRM",
  requiresAuth: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore, params }) => {
    try {
      const accountDashboardStore =
        rootStore.accountDashboardStore as AccountDashboardStore;

      if (params.id) {
        await accountDashboardStore.loadAccount(params.id as string);
      }

      return true;
    } catch (error) {
      console.error("Failed to load account dashboard:", error);
      return false;
    }
  },
  onParamsChange: async ({ rootStore, params, previousParams }) => {
    if (params.id !== previousParams?.id) {
      const accountDashboardStore =
        rootStore.accountDashboardStore as AccountDashboardStore;

      if (params.id) {
        await accountDashboardStore.loadAccount(params.id as string);
      }
    }
  },
};

export default accountDashboardRoute;
